import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Footer, Header } from "@/components/SiteChrome";
import { Hero } from "@/components/sections/Hero";
import { HealthCheck } from "@/components/sections/HealthCheck";
import { Expertise } from "@/components/sections/Expertise";
import { Services } from "@/components/sections/Services";
import { About } from "@/components/sections/About";
import { SampleReport } from "@/components/sections/SampleReport";
import { Faq } from "@/components/sections/Faq";
import { Contact } from "@/components/sections/Contact";

function App() {
  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.webdriver) return undefined;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;

    const lenis = new Lenis({
      duration: 1.15,
      anchors: { offset: -72 },
    });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ivory text-ink">
      <a
        href="#main"
        data-testid="skip-to-content-link"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-cherry focus:px-4 focus:py-2 focus:text-sm focus:text-ivory"
      >
        Skip to content
      </a>
      <Header />
      <main id="main">
        <Hero />
        <HealthCheck />
        <Expertise />
        <Services />
        <About />
        <SampleReport />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
